import { render, staticRenderFns } from "./newsindex.vue?vue&type=template&id=6a6a033b&scoped=true&"
import script from "./newsindex.vue?vue&type=script&lang=js&"
export * from "./newsindex.vue?vue&type=script&lang=js&"
import style0 from "./newsindex.vue?vue&type=style&index=0&id=6a6a033b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a033b",
  null
  
)

export default component.exports